// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"bf824281","453":"2c49e585"}[chunkId] + ".chunk.js";
};